module.exports = __webpack_public_path__ + "img/organ.8ad48a39.png";